module.exports = __webpack_public_path__ + "static/media/comment_bg.dbda0d83.png";